import { render, staticRenderFns } from "./InductorTable.vue?vue&type=template&id=cca88e5a"
import script from "./InductorTable.vue?vue&type=script&lang=ts"
export * from "./InductorTable.vue?vue&type=script&lang=ts"
import style0 from "./InductorTable.vue?vue&type=style&index=0&id=cca88e5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports